import { render, staticRenderFns } from "./editAppointmentInfo.vue?vue&type=template&id=fb44610c&scoped=true"
import script from "./editAppointmentInfo.vue?vue&type=script&lang=js"
export * from "./editAppointmentInfo.vue?vue&type=script&lang=js"
import style0 from "./editAppointmentInfo.vue?vue&type=style&index=0&id=fb44610c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb44610c",
  null
  
)

export default component.exports